export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      class: 'first-nav-link'
    },
    {
      name: 'Command Centre',
      url: '/commandcentre',
      icon: 'icon-globe'
    },
    {
      name: 'Telemetry',
      url: '/telemetry',
      icon: 'icon-graph'
    },
    {
      name: 'GCU Settings',
      url: '/gcusettings',
      icon: 'icon-settings'
    },
    {
      name: 'Alerts',
      url: '/alerts',
      icon: 'icon-bell'
    },
    {
      name: 'Armature Controller',
      url: '/armcontroller',
      icon: 'icon-screen-smartphone'
    }
  ]
};
